import React, { useState, useEffect, useRef } from 'react';
import './Memory.css';
import classnames from 'classnames';
import data from './Data.js';
import cardBack from './3lg_grey.png';
import { pics } from './Pics';
import { strings } from './Localization';

function debounce(fn, ms) {
  let timer;
  return (_) => {
    clearTimeout(timer);
    timer = setTimeout((_) => {
      timer = null;
      fn.apply(this, arguments);
    }, ms);
  };
}

// const dept = 'AIR & OCEAN';
export function Memory({ dept, onReset }) {
  const generateTiles = (numTiles) => {
    let tiles = [];
    const tilesData = data.filter((d) => d.EQUIPOS === dept);
    try {
      for (let i = 1; i <= numTiles / 2; i++) {
        tiles.push(
          {
            n: tilesData[i - 1].NUM,
            title: tilesData[i - 1].NOMBRE,
            image: pics[tilesData[i - 1].NUM - 1],
          },
          {
            n: tilesData[i - 1].NUM,
            title: tilesData[i - 1].NOMBRE,
            image: pics[tilesData[i - 1].NUM - 1],
          }
        );
        // tiles.push(i, i);
      }
    } catch (err) {
      console.log('ERROR');
      tiles = [];
    }

    return tiles.sort(() => 0.5 - Math.random());
  };

  const refContainer = useRef();
  const [numTiles, setNumTiles] = useState(
    data.filter((d) => d.EQUIPOS === dept).length * 2
  );

  const [tiles, setTiles] = useState(generateTiles(numTiles));
  const [selectedTiles, setSelectedTiles] = useState([]);
  const [matchedTiles, setMatchedTiles] = useState([]);

  const [dimensions, setDimensions] = React.useState({
    height: 1,
    width: 1,
  });
  const [tileSize, setTileSize] = useState(100);
  const [cols, setCols] = useState(1);
  const [rows, setRows] = useState(1);
  useEffect(() => {
    setNumTiles(data.filter((d) => d.EQUIPOS === dept).length * 2);
    setSelectedTiles([]);
    setMatchedTiles([]);
    const debouncedHandleResize = debounce(function handleResize() {
      if (refContainer.current) {
        setDimensions({
          width: refContainer.current.offsetWidth,
          height: refContainer.current.offsetHeight,
        });
      }
      optimizeColsAndRowsDependingOnWindowDimensions();
    }, 1000);

    window.addEventListener('resize', debouncedHandleResize);

    return (_) => {
      window.removeEventListener('resize', debouncedHandleResize);
    };
  }, [dept]);

  useEffect(() => {
    optimizeColsAndRowsDependingOnWindowDimensions();
  }, [numTiles, dimensions]);

  useEffect(() => {
    setTiles(generateTiles(numTiles));
    setSelectedTiles([]);
    setMatchedTiles([]);
  }, [numTiles, dimensions, dept]);

  useEffect(() => {
    if (refContainer.current) {
      setDimensions({
        width: refContainer.current.offsetWidth,
        height: refContainer.current.offsetHeight,
      });
    }
  }, [refContainer]);

  const optimizeColsAndRowsDependingOnWindowDimensions = () => {
    const { width, height } = dimensions;

    let rel = 1;
    rel = Math.trunc(width / height);

    let cols = 1;
    let rows = 1;
    const squared = Math.sqrt(numTiles);
    let tileSize = 1;
    // Perfect square
    if (Math.trunc(Math.sqrt(numTiles)) === squared) {
      cols = squared;
      rows = squared;
      if (width > height) {
        tileSize = Math.trunc(height / cols);
      } else {
        tileSize = Math.trunc(width / cols);
      }
    } else {
      const pCols = Math.trunc(numTiles / rel);
      for (let i = 1; i <= pCols; i++) {
        let tSize = Math.trunc(width / i);

        if (numTiles % i === 0 && (numTiles / i) * tSize <= height) {
          cols = i;
          rows = Math.trunc(numTiles / cols);
          break;
        }
      }
      tileSize = Math.trunc(width / cols);
    }
    setTileSize(tileSize - 16);
    setCols(cols);
    setRows(rows);

    return tileSize;
  };

  const handleTileClick = (index) => {
    if (
      selectedTiles.length < 2 &&
      !selectedTiles.includes(index) &&
      !matchedTiles.includes(index)
    ) {
      const newSelected = [...selectedTiles, index];

      setSelectedTiles(newSelected);

      if (newSelected.length === 2) {
        if (tiles[newSelected[0]].n === tiles[newSelected[1]].n) {
          setMatchedTiles([...matchedTiles, ...newSelected]);
          setSelectedTiles([]);
        } else {
          setTimeout(() => setSelectedTiles([]), 1000);
        }
      }
    }
  };

  return matchedTiles.length === numTiles ? (
    <Message dept={dept} onReset={onReset} />
  ) : (
    <div
      className="tiles"
      ref={refContainer}
      style={{
        gridTemplateColumns: `repeat(${cols}, ${tileSize}px)`,
        gridTemplateRows: `repeat(${rows}, ${tileSize}px)`,
      }}
    >
      {tiles.map((tile, index) => (
        <Tile
          key={index}
          index={index}
          image={tile.image}
          title={tile.title}
          isFlipped={
            selectedTiles.includes(index) || matchedTiles.includes(index)
          }
          onClick={() => handleTileClick(index)}
        />
      ))}
    </div>
  );
}

const Tile = ({
  onClick,
  image,
  title,
  index,
  isInactive,
  isFlipped,
  isDisabled,
}) => {
  const handleClick = () => {
    !isFlipped && !isDisabled && onClick(index);
  };

  return (
    <div
      className={classnames('card', {
        'is-flipped': isFlipped,
        'is-inactive': isInactive,
      })}
      onClick={handleClick}
    >
      <div
        className="card-face card-font-face"
        style={{
          backgroundImage: `url(${cardBack})`,
        }}
      ></div>
      <div
        className="card-face card-back-face"
        style={{
          // backgroundImage: `url(https://picsum.photos/id/${card}/200)`,
          backgroundImage: `url(${image})`,
        }}
      ></div>
    </div>
  );
};

export function Welcome({ logo, menu }) {
  return (
    <div className="welcome">
      {logo}
      <div className="welcomeText">
        <div className="introTitle">{strings.welcomeTitle}</div>
        <div className="introText">{strings.welcomeText}</div>
        <div className="welcomeImage DesktopOnly"> </div>
      </div>
      <div className="MobileOnly">{menu}</div>
      <div className="MobileOnly">
        <div className="welcomeImage"> </div>
      </div>
    </div>
  );
}

export function Message({ onReset, dept }) {
  return (
    <div className="message">
      <div className="messageText">
        <div className="introTitle">{strings.congratulations}</div>
        <div className="introText">{strings[dept]}</div>
        <div className="RestartButton" onClick={onReset}>
          <div className="introText">{strings.selectAnother}</div>
        </div>
      </div>
      <div className="contactTitle">
        {strings.contactOurTeam} {strings[`${dept.toUpperCase()} Title`]}
      </div>
      <div className="contactPeople">
        {data
          .filter((d) => d.EQUIPOS === dept)
          .map((d) => (
            <div className="contactPerson">
              <img src={pics[d.NUM - 1]} alt={d.NOMBRE} />
              <div>
                <div className="contactPersonName">
                  {d.NOMBRE}
                  <br />
                  {d.APELLIDOS}
                </div>
                <div className="contactPersonTitle">
                  {strings.getLanguage() === 'es' ? d.CARGO : d.CARGO_EN}
                </div>
                <div className="contactPersonEmail">{d.EMAIL}</div>
                <div className="contactPersonPhone">{d.TELÉFONO}</div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
